module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity-new/design-tile-images/design-tile-02-18fb81dc6ff06efc157d0a76516dc9c4.jpg";